/** Q12 of the Nov 2026 form (Zohal, Nov 3 2026): the wording and options exactly as in the form. */
import type { PromotionChoice } from '../../types/managerReviewV2';

export const PROMOTION_QUESTION = 'I am putting this employee forward for:';

export const PROMOTION_OPTIONS: { value: PromotionChoice; label: string }[] = [
  { value: 'yes', label: 'Promotion in this cycle' },
  { value: 'conditional', label: 'Conditional promotion in June 2027' },
  { value: 'no', label: 'Neither promotion in this cycle nor a conditional promotion in June 2027' },
];

export const CONDITIONAL_PROMOTION_NOTE =
  'Putting someone up for a conditional promotion means that the employee will not be put up for promotion this cycle but we will reconsider their performance in June 2027. This is applicable for employees that already demonstrate some next-level expectations but still have minor development areas to address. The promotion will only proceed if the expectations are met by June 2027.';
